import { useQueryClient } from '@tanstack/react-query'
import { Button, FocusTrap, Group, Modal, Stack } from '@mantine/core'
import { useDeleteArenaPost } from './api'
import classes from './Arena.module.css'
import { useParams } from 'react-router'

export default function DeletePost({
  post_id,
  openedDeleteModal,
  closeDeleteModal,
}: {
  post_id: number
  openedDeleteModal: boolean
  closeDeleteModal: () => void
}) {
  const queryClient = useQueryClient()
  const { mutate: deleteArenaPost, isPending } = useDeleteArenaPost()
  const { competitionId } = useParams()

  function handleDeleteArenaPost() {
    deleteArenaPost(
      {
        competition_id: Number(competitionId),
        post_id: post_id,
      },
      {
        onSuccess: async () => {
          await queryClient.invalidateQueries({
            queryKey: ['arenaPosts'],
          })
          closeDeleteModal()
        },
      }
    )
  }

  return (
    <Modal
      classNames={{ title: classes.modalTitle }}
      opened={openedDeleteModal}
      onClose={closeDeleteModal}
      withCloseButton={false}
      centered
      size="xs"
      overlayProps={{
        backgroundOpacity: 0.3,
        blur: 2,
      }}
      transitionProps={{
        transition: 'fade',
        duration: 200,
        exitDuration: 150,
        timingFunction: 'ease-out',
      }}
    >
      <FocusTrap.InitialFocus />
      <Stack align="center">
        <p>Are you sure you want to delete this post?</p>
        <Group w="full" justify="center">
          <Button
            className={classes.closeModalButton}
            onClick={closeDeleteModal}
          >
            Cancel
          </Button>
          <Button
            className={classes.deleteButton}
            onClick={handleDeleteArenaPost}
            loading={isPending}
            disabled={isPending}
          >
            Delete
          </Button>
        </Group>
      </Stack>
    </Modal>
  )
}
